import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases de Tailwind, resolviendo conflictos automáticamente.
 * Ejemplo: cn("px-2 py-1", condition && "px-4")
 * → "py-1 px-4" (twMerge resuelve el conflicto de px-*).
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
